import { render, staticRenderFns } from "./goalModal.vue?vue&type=template&id=68bdf5a0&scoped=true&"
import script from "./goalModal.vue?vue&type=script&lang=js&"
export * from "./goalModal.vue?vue&type=script&lang=js&"
import style0 from "./goalModal.vue?vue&type=style&index=0&id=68bdf5a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bdf5a0",
  null
  
)

export default component.exports